import { displayMessage } from "../../../../helpers/messages";

const gym_workout_grid_columns = [
    // Opções de dor no corpo para mapeamento
    {
        field: "body_pain",
        headerName: "DOR NO CORPO",
        flex: 1,
        minWidth: 120,
        valueGetter: (params) => {
            const map = {
                'none': 'Não sinto dores',
                'lower_back': 'Na lombar',
                'shoulder': 'No ombro',
                'knee': 'No joelho'
            };
            return map[params.row?.body_pain] || params.row?.body_pain || '-';
        },
    },
    {
        field: "id",
        headerName: displayMessage("ID"),
        flex: 0.5,
        minWidth: 60,
    },
    {
        field: "name",
        headerName: displayMessage("WORKOUT_NAME"),
        flex: 2,
        minWidth: 200,
    },
    {
        field: "gender_description",
        headerName: displayMessage("GENDER"),
        flex: 1,
        minWidth: 120,
    },
    {
        field: "weekly_frequency",
        headerName: displayMessage("WEEKLY_FREQUENCY"),
        flex: 1,
        minWidth: 120,
        renderCell: (params) => {
            return `${params.value}x ${displayMessage("WEEK").toLowerCase()}`;
        },
    },
    {
        field: "duration_minutes",
        headerName: displayMessage("DURATION_MINUTES"),
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            if (!params.value) return "-";
            return `${params.value} min`;
        },
    },
    {
        field: "order_index",
        headerName: displayMessage("ORDER_INDEX"),
        flex: 0.5,
        minWidth: 80,
    },
    {
        field: "sequence",
        headerName: displayMessage("SEQUENCE"),
        flex: 0.6,
        minWidth: 90,
        valueGetter: (params) => params.row?.sequence ?? 1,
    },
    {
        field: "exercises_count",
        headerName: displayMessage("EXERCISES"),
        flex: 1,
        minWidth: 100,
        valueGetter: (params) => {
            return params.row?.exercises?.length || 0;
        },
    },
];

// Colunas da Etapa 2 (dentro de uma combinação já selecionada).
// Omite os campos que definem a combinação (gender, weekly_frequency,
// body_pain, duration_minutes) pois são fixos dentro do agrupamento,
// e coloca a sequência em primeiro lugar como ordenador principal.
const gym_workout_grid_columns_stage2 = [
    {
        field: "sequence",
        headerName: displayMessage("SEQUENCE"),
        flex: 0.6,
        minWidth: 90,
        valueGetter: (params) => params.row?.sequence ?? 1,
    },
    {
        field: "id",
        headerName: displayMessage("ID"),
        flex: 0.5,
        minWidth: 60,
    },
    {
        field: "name",
        headerName: displayMessage("WORKOUT_NAME"),
        flex: 2,
        minWidth: 200,
    },
    {
        field: "order_index",
        headerName: displayMessage("ORDER_INDEX"),
        flex: 0.5,
        minWidth: 80,
    },
    {
        field: "exercises_count",
        headerName: displayMessage("EXERCISES"),
        flex: 1,
        minWidth: 100,
        valueGetter: (params) => params.row?.exercises?.length || 0,
    },
];

export default gym_workout_grid_columns;
export { gym_workout_grid_columns_stage2 };


